import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const aboutPathMap = localizePathMap({
	[Locale.cs]: "o-nas",
	[Locale.en]: "about",
});
